export default __webpack_public_path__ + "static/media/NIE_touchpoint_13.5b79208d.mp4";